export default {
  methods: {
    async checktoken() {
      const params = new URLSearchParams(window.location.search);
      if (params.has('token')) {
        const token = params.get('token');
        localStorage.setItem('token', token);

      } else {
        
      }
      if (localStorage.getItem('token') === null || localStorage.getItem('token') === '') {
        return false;
      }
      return true;
    },
    async GetUserInfo() {
      try {
        const res = await this.$axios({
          method: "get",
          url: 'https://xfm-julife-b.itsesg.work/api/user/info',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
            //Authorization: `Bearer qjvlenOeUdN5N9lyl443rAE1SflULgPckzNaAlKgb3c139c8`
          }
        })
       
        //console.log(res.data);
        if (res.data.message == "Unauthenticated.") {
          return false;
        }
        if (res.data.ResponseInfo != undefined) {
                  
          const infodata = res.data.ResponseInfo;
          const Communitiesdata = Object.values(infodata.Communities)[0]
          this.$cookieFunc.setCookie(
            'Userid',
            this.$Global.Base64Utils.utoa(Communitiesdata.Householders[0].Id),
            60 * 60 * 24 * 30
          );
          this.$cookieFunc.setCookie(
            'ShopNO',
            this.$Global.Base64Utils.utoa(Communitiesdata.Id),
            60 * 60 * 24 * 30
          );
          this.$cookieFunc.setCookie(
            'uAugroup',
            this.$Global.Base64Utils.utoa(''),
            60 * 60 * 24 * 30
          );
          const Homeid = Communitiesdata.Householders[0].Building + Communitiesdata.Householders[0].Floor + Communitiesdata.Householders[0].HouseholdIdentifier;
          this.$cookieFunc.setCookie(
            'Homeid',
            this.$Global.Base64Utils.utoa(Homeid),
            60 * 60 * 24 * 30
          );
          this.$cookieFunc.setCookie(
            'UserName',
            this.$Global.Base64Utils.utoa(infodata.User.Name),
            60 * 60 * 24 * 30
          );
          this.$cookieFunc.setCookie(
            'Mobile',
            this.$Global.Base64Utils.utoa(infodata.User.Phone),
            60 * 60 * 24 * 30
          );
          return true
        }
        return false;
      }
      catch (error) {
        console.log(error);
        return false;
      };
    
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/checkLoginMixin.js